<div class="filter-button" (click)="op.toggle($event)" matRipple [matRippleCentered]="true" *ngIf="types.length > 1">
    <button mat-button disableRipple="true">
      <mat-icon>filter_list</mat-icon>
    </button>
    <div class="types-info" *ngIf="filterIsOn">{{countTypes}} types</div>
</div>

<p-overlayPanel #op styleClass="schedule-filter-panel">
  <div class="checkboxes">
    <p-checkbox class="all-button" label="All" name="types" [binary]="true" [(ngModel)]="showAll"
                (click)="showAllButton()"></p-checkbox>
    <p-checkbox *ngFor="let type of types" label="{{type.name}}" name="types" value="{{type.name}}"
                [(ngModel)]="selectedPosts" (click)="filter()"></p-checkbox>
  </div>

</p-overlayPanel>


